import { fetchApi } from './helpers'

/**
 * A device signal for a moment with no request of its own (BOAT-1895).
 *
 * The first landing, an add to cart, the start of a checkout. Everything else —
 * an order, a login, a cart, a signup — carries the same device block on the
 * request it was already making, so this endpoint stays the exception rather
 * than becoming a page-view beacon.
 */
export const recordDeviceSignal = (body: {
  signal: string
  device: { visitor_id: string; components?: Record<string, unknown> }
}) =>
  fetchApi(`/devices/signal`, {
    method: 'POST',
    body,
  })
